import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useGetUser } from 'src/app/common/hooks/users/useGetUser';
import { PAGES } from 'src/app/common/types/types';

export const AuthenticatedLayout = () => {
  const route = useLocation();
  const { user, isLoading: isLoadingUser } = useGetUser();

  if (isLoadingUser && !user) {
    return null;
  }

  if (!isLoadingUser && !user) {
    return <Navigate to={`/${PAGES.SIGN_IN}`} />;
  }

  const isOnboardingFinished = user!.onboardingFinished;
  const isOnboardingPage = route.pathname === `/${PAGES.ONBOARDING}`;

  if (!isOnboardingFinished && !isOnboardingPage) {
    return <Navigate to={`/${PAGES.ONBOARDING}`} />;
  }

  if (isOnboardingPage && isOnboardingFinished) {
    return <Navigate to={`${PAGES.HOME}`} />;
  }

  return <Outlet />;
};
